import { useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { ApiContext } from '../App';
import { EntitiesContext } from '../App';
import * as ActionTypes from '../constants/action-types';

export const useGetLists = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  const lists = useQuery('lists', () => api.get(`/lists`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  });

  return lists;
}

export const useGetList = type => {
  const entities = useContext(EntitiesContext);

  return entities.state.get('list').filter(l => l.type === type);
}
